import React from "react";

interface LoadingOverlayProps {
  isVisible: boolean;
  message?: string;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  isVisible,
  message = "Loading...",
}) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-md">
      <div className="flex flex-col items-center space-y-2">
        <div className="text-4xl">🔥</div>
        <p className="text-lg font-semibold text-gray-200">{message}</p>
      </div>
    </div>
  );
};

LoadingOverlay.defaultProps = {
  message: "Loading...",
};

export default LoadingOverlay;
